import { TGroupResourceWithGroupId } from '@/shared/features/groups/components/move-resources/move-resources.types';
import { TGroupResourceItem } from '@/shared/features/groups/context/groups-config-context.types';
import { ResourceGroupFragment } from '@/shared/types/types.generated';

export const isResourceGroup = (
  resource: TGroupResourceItem,
): resource is TGroupResourceItem & ResourceGroupFragment =>
  resource.__typename === 'ResourceGroupResponseType';

export const hasGroupId = (
  resource: TGroupResourceItem,
): resource is TGroupResourceWithGroupId => 'groupId' in resource;

export const isRootGroup = (
  resource: TGroupResourceItem,
): resource is TGroupResourceItem & ResourceGroupFragment =>
  isResourceGroup(resource) && !resource.parentGroupId;

export const getInitialGroupId = (
  resources: TGroupResourceItem[],
  currentGroupId: string | undefined,
) => {
  if (resources.length === 1 && hasGroupId(resources[0])) {
    return resources[0].groupId;
  }

  return currentGroupId;
};
